import React from "react";
import { Menu, Send } from "lucide-react";
import { Drawer, DrawerClose, DrawerContent, DrawerFooter, DrawerHeader, DrawerTitle, DrawerTrigger } from "@/components/ui/drawer";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { trackFormTriggerClicked } from "@/lib/posthog";
interface MobileNavigationProps {
  isScrolled: boolean;
  isOpen: boolean;
  isMenuOpen: boolean;
  setIsMenuOpen: (value: boolean) => void;
  onOpenForm: () => void;
}
const MobileNavigation: React.FC<MobileNavigationProps> = ({
  isScrolled,
  isOpen,
  isMenuOpen,
  setIsMenuOpen,
  onOpenForm
}) => {
  const closeMenu = () => {
    setIsMenuOpen(false);
  };
  return <div className="md:hidden">
      <Button variant="ghost" size="icon" className="md:hidden z-[80]" onClick={() => setIsMenuOpen(true)}>
        <Menu className={`h-6 w-6 ${isScrolled ? 'text-gray-700' : 'text-white'}`} />
      </Button>

      <Drawer open={isMenuOpen} onOpenChange={setIsMenuOpen}>
        <DrawerContent className="h-[85vh] rounded-t-none rounded-b-[10px] overflow-y-auto no-scrollbar">
          <DrawerHeader>
            <DrawerTitle className="text-center text-xl">Naboo</DrawerTitle>
          </DrawerHeader>
          <div className="px-4 py-2 flex flex-col space-y-4">
            <Link to="/destinations" className="text-lg font-normal py-3 border-b border-gray-100" onClick={closeMenu}>
              Nos destinations
            </Link>
            
            <Link to="/about-us" className="text-lg font-normal py-3 border-b border-gray-100" onClick={closeMenu}>
              À propos
            </Link>

            <Link to="/tools" className="text-lg font-normal py-3 border-b border-gray-100" onClick={closeMenu}>
              Nos outils
            </Link>
            
          </div>
          <DrawerFooter>
            <Button onClick={() => {
            onOpenForm();
            closeMenu();
          }} className="w-full bg-cta-green text-cta-green-foreground hover:bg-cta-green/90 rounded-xl">
              <Send className="h-4 w-4 mr-1" />
              Envoyer un brief
            </Button>
            <DrawerClose asChild>
              <Button variant="outline" className="w-full">Fermer le menu</Button>
            </DrawerClose>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </div>;
};
export default MobileNavigation;